import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { slackService } from '../services/slackService';

export const emojiKeys = {
  all: ['emojis'] as const,
  map: () => [...emojiKeys.all, 'map'] as const,
};

export const useEmojis = () => {
  return useQuery<Record<string, string>>({
    queryKey: emojiKeys.map(),
    queryFn: () => slackService.getEmojis(),
    staleTime: 1000 * 60 * 30, // 30 minutes - emojis don't change often
    refetchOnWindowFocus: false,
  });
};

export const useSyncEmojis = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => slackService.syncEmojis(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: emojiKeys.all });
    },
  });
};
